import { CLOSE_ALERT } from '../actionTypes';

const closeAlert = () => ({
  type: CLOSE_ALERT,
});

export default closeAlert;
